'use strict';

var _regeneratorRuntime = require("/Users/nick/upgrowth/deepforest/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _firekit3 = require('./firekit');

var _firekit4 = _interopRequireDefault(_firekit3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var withUserId = function withUserId(BoundComponent) {
  return function (_React$PureComponent) {
    _inherits(WithUserId, _React$PureComponent);

    function WithUserId(props) {
      _classCallCheck(this, WithUserId);

      var _this = _possibleConstructorReturn(this, (WithUserId.__proto__ || Object.getPrototypeOf(WithUserId)).call(this, props));

      _this.state = {};

      var _firekit = (0, _firekit4.default)(),
          auth = _firekit.auth;

      _this.state = {
        user: auth.currentUser
      };
      return _this;
    }

    _createClass(WithUserId, [{
      key: 'componentDidMount',
      value: function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var _this2 = this;

          var _firekit2, auth, user;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _firekit2 = (0, _firekit4.default)(), auth = _firekit2.auth;
                  user = auth.currentUser;
                  _context.next = 4;
                  return new Promise(function (resolve) {
                    return _this2.setState({
                      user: user
                    }, resolve);
                  });

                case 4:
                  this.observe = auth.onAuthStateChanged(function (user) {
                    return _this2.setState({
                      user: user
                    });
                  });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidMount() {
          return _ref.apply(this, arguments);
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.observe && this.observe();
        delete this.observe;
      }
    }, {
      key: 'render',
      value: function render() {
        var uid = this.state.user ? this.state.user.uid : undefined;
        return React.createElement(BoundComponent, _extends({}, this.props, {
          userId: uid
        }));
      }
    }]);

    return WithUserId;
  }(React.PureComponent);
};

exports.default = withUserId;